import type { LocaleCode } from '~/i18n/config'

// Locale → Shopware property option UUID for the "Sprache" property group
// (group id `be17abe9bdb04bc996acd79b7e2d5437`, see careum-shop CareumDefaults).
// UUIDs verified identical on dev and prod via the Store API on 2026-04-30 (CARW-1626).
// Stage was VPN-blocked at the time and should be confirmed before deploy.
const OPTION_IDS: Record<LocaleCode, string> = {
  de: '4d91c808816b4b149c6fea34c9dfa317',
  fr: 'a62ab70079684eac8bb680e1800261a5',
  it: '198f3c8dd33e4044ac1574638f442baa',
  en: '2d3aa19ce5804459a6358e0b0be96bd6',
}

export const useShopLanguagePropertyOptions = () => {
  const idForLocale = (code: LocaleCode) => OPTION_IDS[code]
  const allIds = Object.values(OPTION_IDS)

  return { idForLocale, allIds, OPTION_IDS }
}
